export default "__VITE_ASSET__45ec6765__"